import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import NxtTopBar from '../../../basic/nxt-top-bar';
import ChangePasswordForm from './change-password-form';
import { changePassword } from '../../../business/home/appStateSlice';
import IxSnackbar from '../../../basic/ix-snackbar';

const TakeoutChangePassword = () => {
  const [error, setError] = useState(null);
  const { t, i18n } = useTranslation();
  let history = useHistory();
  const userId = useSelector(state => state.appState.loginUser.data.user.id);
  const userName = useSelector(
    state => state.appState.registeredUser.data.email
  );

  const dispatch = useDispatch();

  const handleChangePassword = values => {
    if (values.newPassword !== values.confirmPassword) {
      setError('New password and confirmed password are not same');
    } else {
      dispatch(changePassword({ userName, ...values }, userId, history));
    }
  };
  return (
    <div>
      {' '}
      <NxtTopBar children={t('Change Password')} />
      <ChangePasswordForm onSubmit={handleChangePassword} />
      {error && (
        <IxSnackbar
          errorMessage={error}
          handleSnackbarClose={() => setError(null)}
        />
      )}
    </div>
  );
};

export default TakeoutChangePassword;
